import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import parse from "html-react-parser";
import { kmLabels } from "src/constant/Texts";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  }
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { headCells, classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) =>
          headCell.sortable ? (
            <TableCell
              width={headCell.width}
              key={headCell.id}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ) : (
            <TableCell
              width={headCell.width}
              component={headCell.label ? "th" : "td"}
              key={headCell.id}
            >
              {headCell.label}
            </TableCell>
          )
        )}
      </TableRow>
    </TableHead>
  );
}

const CustomTableCell = ({ row, name, lp, isHtml, dataType, dataLabels }) => {
  const classes = useStyles();

  const getValueOrDefault = (value, dataType, dataLabels) => {
    if (value) {
      if (dataType) {
        switch (dataType) {
          case 0:
            if (dataLabels && dataLabels.length === 2) {
              return value ? dataLabels[0] : dataLabels[1];
            } else {
              return value;
            }
          case 1:
            return parse(`<ul><li>${value.join("</li><li>")}</li></ul>`);
          case 2:
            return (dataLabels && dataLabels[value]) ? dataLabels[value] : "??nolabel??";
          default:
            return value;
        }
      }
      return value;
    }
    return kmLabels.global.empty_value_indicator;
  };

  return (
    <TableCell key={`${row.id}_${name}`} align="left" className={classes.tableCell}>
      {lp ? lp : isHtml ? parse(row[name]) : getValueOrDefault(row[name],dataType, dataLabels)}
    </TableCell>
  );
};

function KmFormPreviewTable({ columns, rows, caption, ...rest }) {
  const classes = useStyles();
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("id");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  

  return (
    <Table className={classes.table} aria-label="caption table">
      {caption ? <caption>{caption}</caption> : <></>}
      {/* <TableHead>
        <TableRow>
          {columns.map((cell) => (
            <TableCell width={cell.width} align="left">
              {cell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead> */}
      <EnhancedTableHead
        headCells={columns}
        classes={classes}
        order={order}
        orderBy={orderBy}
        onRequestSort={handleRequestSort}
      />
      <TableBody>
        {stableSort(rows, getComparator(order, orderBy)).map((row, index) => (
          <TableRow key={row.id}>
            {columns.map((cell) => (
              <CustomTableCell key={`ctc${cell.fieldName}_${row.id}`}
                {...{
                  row,
                  name: cell.fieldName,
                  lp: cell.isLp ? index + 1 : null,
                  isHtml: cell.isHtml,
                  dataType: cell.dataType,
                  dataLabels: cell.dataLabels
                }}
              />
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default KmFormPreviewTable;
